
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marques",
      function () {
        return require("private-next-pages/[locale]/marques/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marques"])
      });
    }
  